import type {
  StartVisitCounselDepartureAddress,
  StructuredDepartureAddress,
} from '@/entities/visit-counsel/model/visit-counsel.types';

/**
 * StructuredDepartureAddress (Response) → StartVisitCounselDepartureAddress
 * (Request body 호환). 옛 `useIntakeForm` 의 동일 로컬 헬퍼와 1:1 호환.
 *
 * floor / unit 은 둘 중 하나만 채워지고 나머지는 null.
 */
export function structuredToStartAddress(
  addr: StructuredDepartureAddress
): StartVisitCounselDepartureAddress {
  const fu = addr.floorOrUnit;
  return {
    roadAddress: addr.roadAddress,
    buildingName: addr.buildingName ?? null,
    dong: addr.dong ?? null,
    floor: fu?.type === 'Floor' ? fu.value : null,
    unit: fu?.type === 'Unit' ? fu.value : null,
  };
}

/**
 * Request body 호환 형식 → StructuredDepartureAddress (Response 형태). UI prefill.
 */
export function startToStructuredAddress(
  addr: StartVisitCounselDepartureAddress
): StructuredDepartureAddress {
  const floorOrUnit = addr.floor
    ? ({ type: 'Floor' as const, value: addr.floor } as const)
    : addr.unit
      ? ({ type: 'Unit' as const, value: addr.unit } as const)
      : null;
  return {
    roadAddress: addr.roadAddress,
    buildingName: addr.buildingName ?? null,
    dong: addr.dong ?? null,
    floorOrUnit,
  };
}
